import { MESSAGE } from "constants/Message";

export const JSON_ERROR_MSG = "Not a valid JSON";
export const JSON_VALID_MSG = "JSON valid";

export const JSON_FORMAT_MSG = {
  [MESSAGE.ERROR]: JSON_ERROR_MSG,
  [MESSAGE.SUCCESS]: JSON_VALID_MSG,
};

export function checkIsValidJson(jsonText) {
  try {
    return JSON.parse(jsonText);
  } catch (err) {
    return null;
  }
}

export function stringifyJson(jsonObj) {
  try {
    return JSON.stringify(jsonObj, null, 4);
  } catch (err) {
    return null;
  }
}
